var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-topmenu themeable"},[_c('Tabs',{attrs:{"value":_vm.value,"animated":false}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/menu/topMenu.vue